module.exports = __webpack_public_path__ + "img/local-market-icon.ffbcefbe.svg";